import { useState, useCallback } from "react";

import {
  ConversationNode,
  ConversationState,
  NavigationHistory,
} from "@/commands/AIConcierge/types";

export const useConversation = (initialData: ConversationNode) => {
  const [state, setState] = useState<ConversationState>({
    currentNode: initialData,
    history: [],
    currentPath: [],
  });

  // 選択肢をクリックした時の処理
  const selectChoice = useCallback((choiceIndex: number) => {
    setState((prevState) => {
      const { currentNode, history, currentPath } = prevState;

      // 現在のノードを履歴に追加
      const newHistory: NavigationHistory[] = [
        ...history,
        {
          node: currentNode,
          parentPath: [...currentPath],
        },
      ];

      // 子ノードに移動
      if (currentNode.children && currentNode.children.length > choiceIndex) {
        const nextNode = currentNode.children[choiceIndex];
        const newPath = [...currentPath, choiceIndex];

        return {
          currentNode: nextNode,
          history: newHistory,
          currentPath: newPath,
        };
      }

      return prevState;
    });
  }, []);

  // 一つ戻る処理
  const goBack = useCallback(() => {
    setState((prevState) => {
      const { history } = prevState;

      if (history.length > 0) {
        const lastHistory = history[history.length - 1];
        const newHistory = history.slice(0, -1);

        return {
          currentNode: lastHistory.node,
          history: newHistory,
          currentPath: lastHistory.parentPath,
        };
      }

      return prevState;
    });
  }, []);

  // 最初に戻る処理
  const goToStart = useCallback(() => {
    setState({
      currentNode: initialData,
      history: [],
      currentPath: [],
    });
  }, [initialData]);

  // 現在のノードが最終回答かどうか
  const isFinalAnswer =
    state.currentNode.isFinalAnswer ||
    (state.currentNode.children && state.currentNode.children.length === 0);

  return {
    currentNode: state.currentNode,
    canGoBack: state.history.length > 0,
    isFinalAnswer,
    selectChoice,
    goBack,
    goToStart,
  };
};
